// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__zVKC5","error":"Textarea_error__2su9I","readonly":"Textarea_readonly__3yMOs","disabled":"Textarea_disabled__PxJvl"};